<template>
  <image-list :list="list" />
</template>

<script>
import ImageList from "@/components/ImageList.vue";

export default {
  name: "malerier",
  components: {
    ImageList
  },
  data() {
    return {
      list: [
        {
          id: 1,
          type: "LeftRightText",
          leftImage: "/images/malerier/1/center.jpg",
          leftImageHeight: 450,
          leftText: "VENEZIA PUNTA DELLA DOGNA",
          rightText: ""
        },
        {
          id: 2,
          type: "LeftRight",
          leftImage: "/images/malerier/2/left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/malerier/2/right.jpg",
          rightImageHeight: 370,
          leftText: "VENEZIA ZITELLE REDENTORE",
          rightText: ""
        },
        {
          id: 3,
          type: "LeftRight",
          leftImage: "/images/malerier/3/left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/malerier/3/right.jpg",
          rightImageHeight: 370,
          leftText: "VENEZIA SALUTE SAN VIO",
          rightText: ""
        },
        {
          id: 33,
          type: "Center",
          centerImage: "/images/malerier/33/center.jpg",
          leftText: "VENEZIA 2023",
          rightText: ""
        },
        {
          id: 4,
          type: "LeftRight",
          leftImage: "/images/malerier/4/left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/malerier/4/right.jpg",
          rightImageHeight: 370,
          leftText: "ROMA PORTICO DI OTTAVIA PIAZZA DELLA ROTONDA",
          rightText: ""
        },
        {
          id: 5,
          type: "Center",
          centerImage: "/images/malerier/5/5.jpg",
          leftText: "ROMA PONTE SISTO",
          rightText: ""
        },
        {
          id: 6,
          type: "Center",
          centerImage: "/images/malerier/6/6.jpg",
          leftText: "ROMA PALAZZO SPADA",
          rightText: ""
        },
        {
          id: 7,
          type: "Center",
          centerImage: "/images/malerier/7/7.jpg",
          leftText: "ROMA PALATINO",
          rightText: ""
        },
        {
          id: 8,
          type: "Center",
          centerImage: "/images/malerier/8/8.jpg",
          leftText: "SAN CATALDO",
          rightText: ""
        },
        {
          id: 9,
          type: "Center",
          centerImage: "/images/malerier/9/9.jpg",
          leftText: "MINUTA",
          rightText: ""
        },
        {
          id: 10,
          type: "LeftRight",
          leftImage: "/images/malerier/10/left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/malerier/10/right.jpg",
          rightImageHeight: 370,
          leftText: "SCALA TORELLO",
          rightText: ""
        },
        {
          id: 11,
          type: "Center",
          centerImage: "/images/malerier/11/11.jpg",
          leftText: "PONTONE",
          rightText: ""
        },
        {
          id: 12,
          type: "Center",
          centerImage: "/images/malerier/12/12.jpg",
          leftText: "PONTONE",
          rightText: ""
        },
        {
          id: 13,
          type: "Center",
          centerImage: "/images/malerier/13/13.jpg",
          leftText: "SICILIEN SELINUNTE TEMPEL C",
          rightText: ""
        },
        {
          id: 14,
          type: "Center",
          centerImage: "/images/malerier/14/14.jpg",
          leftText: "PAESTUM TEMPIO DI ATHENA",
          rightText: ""
        },
        {
          id: 15,
          type: "Center",
          centerImage: "/images/malerier/15/15.jpg",
          leftText: "ATHEN ERECHTHEION",
          rightText: ""
        },
        {
          id: 16,
          type: "Center",
          centerImage: "/images/malerier/16/16.jpg",
          leftText: "ATHEN ERECHTHEION",
          rightText: ""
        },
        {
          id: 17,
          type: "LeftRight",
          leftImage: "/images/malerier/17/17-left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/malerier/17/17-right.jpg",
          rightImageHeight: 370,
          leftText: "ATHEN AKROPOLIS ZEUS TEMPLET",
          rightText: ""
        },
        {
          id: 18,
          type: "LeftRight",
          leftImage: "/images/malerier/18/18-left.jpg",
          leftImageHeight: 367,
          rightImage: "/images/malerier/18/18-right.jpg",
          rightImageHeight: 367,
          leftText: "ATHEN HADRIANS TRIUMFBUE LYSIKRATES",
          rightText: ""
        },
        {
          id: 19,
          type: "Center",
          centerImage: "/images/malerier/19/19.jpg",
          leftText: "ATHEN HEPHAESTUS TEMPLET",
          rightText: ""
        },
        {
          id: 20,
          type: "LeftRight",
          leftImage: "/images/malerier/20/20-left.jpg",
          leftImageHeight: 380,
          rightImage: "/images/malerier/20/20-right.jpg",
          rightImageHeight: 380,
          leftText: "ASWAN ELEFANTINE",
          rightText: ""
        },
        {
          id: 21,
          type: "LeftRight",
          leftImage: "/images/malerier/21/21-left.jpg",
          leftImageHeight: 350,
          rightImage: "/images/malerier/21/21-right.jpg",
          rightImageHeight: 350,
          leftText: "DAMASKUS SINAN PASHA MOSKE KHAN ASAD PASHA",
          rightText: ""
        },
        {
          id: 22,
          type: "Center",
          centerImage: "/images/malerier/22/22.jpg",
          leftText: "SYRIEN MALULA",
          rightText: ""
        },
        {
          id: 23,
          type: "LeftRight",
          leftImage: "/images/malerier/23/23-left.jpg",
          leftImageHeight: 370,
          rightImage: "/images/malerier/23/23-right.jpg",
          rightImageHeight: 370,
          leftText: "KALØ SØNDERHO",
          rightText: ""
        },
        {
          id: 24,
          type: "LeftRight",
          leftImage: "/images/malerier/24/24-left.jpg",
          leftImageHeight: 350,
          rightImage: "/images/malerier/24/24-right.jpg",
          rightImageHeight: 350,
          leftText: "VELLING KIRKE TRANS KIRKE",
          rightText: ""
        },
      ]
    };
  }
};
</script>
